import { render, staticRenderFns } from "./protocolRecord.vue?vue&type=template&id=860cdd8c&scoped=true"
import script from "./protocolRecord.vue?vue&type=script&lang=js"
export * from "./protocolRecord.vue?vue&type=script&lang=js"
import style0 from "./protocolRecord.vue?vue&type=style&index=0&id=860cdd8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860cdd8c",
  null
  
)

export default component.exports